var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import auth from '@/router/guards/auth';
import home from '@/router/guards/home';
import verified from '@/router/guards/verified';
import Index from '@/pages/Index.vue';
import Board from '@/pages/Board.vue';
import Login from '@/pages/Login.vue';
import Setup from '@/pages/Setup.vue';
import Verify from '@/pages/Verify.vue';
import Email from '@/pages/Email.vue';
import Error from '@/pages/Error.vue';
import account from '@/router/routes/account';
import assistances from '@/router/routes/assistances';
import compilations from '@/router/routes/compilations';
import experiments from '@/router/routes/experiments';
import onboarding from '@/router/routes/onboarding';
import podcasts from '@/router/routes/podcasts';
import practices from '@/router/routes/practices';
import profiles from '@/router/routes/profiles';
import settings from '@/router/routes/settings';
import various from '@/router/routes/various';
var routes = [
    {
        path: '/app',
        component: Board,
        beforeEnter: [auth, verified],
        redirect: { name: 'dashboard' },
        children: __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], account, true), assistances, true), compilations, true), experiments, true), onboarding, true), podcasts, true), practices, true), profiles, true), settings, true), various, true),
    },
    {
        path: '/',
        name: 'index',
        component: Index,
        beforeEnter: [home],
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        beforeEnter: [home],
    },
    {
        path: '/setup',
        name: 'setup',
        component: Setup,
        beforeEnter: [home],
    },
    {
        path: '/verify',
        name: 'verify',
        component: Verify,
    },
    {
        path: '/email',
        name: 'email',
        component: Email,
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'default',
        component: Error,
    },
];
export default routes;
